import "./StorageVideo.css";

const StorageVideo = ({ storageVideo, setDeleteVideo }) => {
  const encodedVideoPath = encodeURIComponent(storageVideo);
  return (
    <div>
      <h4>Snimak iz baze</h4>
      <div className="storageImagesContainer">
        <div className="storagePhotoContainer">
          <video className="video-preview" controls>
            <source
              src={`https://api.admin.meetserbia.rs/images/${encodedVideoPath}`}
              type="video/mp4"
            ></source>
          </video>
          <span
            className="removeBtn"
            onClick={() => setDeleteVideo(storageVideo)}
          >
            x
          </span>
        </div>
      </div>
    </div>
  );
};

export default StorageVideo;
